<template>
  <div
    class="tag-list-popup"
    ref="taglist"
    :class="{'is--open':open}"
  >
    <div
      class="tag-list-popup_title"
      @click.stop="toggleTagsPopup"
    >
      <span class="tag-list-popup_title_text">{{ label }}:</span>
      <span
        class="tag-list-popup_title_count"
        :class="(taglist.length > 0)?'is--active':''"
      >{{ taglist.length }}</span>
    </div>
    <div class="tag-list-popup_content" :class="{ 'select': type == 'select' }">
      <div v-if="type == 'select'" class="tag-list-popup_content_wrapper">
        <tag-select v-model="taglist" :options="options" />
      </div>
      <div v-else class="tag-list-popup_content_wrapper">
        <tag-list v-model="taglist" />
      </div>

    </div>
  </div>
</template>
<script>
import TagList from 'components/UIComponents/Tags/TagList.vue'
import TagSelect from 'components/UIComponents/Tags/TagSelect.vue'
export default {
  name: 'TagListPopup',
  components: {
    TagList,
    TagSelect
  },
  props: {
    type: String,
    label: String,
    value: Array,
    options: Array
  },
  data () {
    return {
      open: false,
      taglist: []
    }
  },
  watch: {
    taglist () {
      this.$emit('input', this.taglist)
    },
    value () {
      this.taglist = this.value
    }
  },
  mounted () {
    this.taglist = this.value
  },
  created () {
    window.addEventListener('click', this.closeTagsPopup)
  },
  beforeDestroy () {
    window.removeEventListener('click', this.closeTagsPopup)
  },
  methods: {
    toggleTagsPopup () {
      this.open = !this.open
      if (this.open && this.type != 'select') {
        this.$el.querySelector(".form-control.border-input").focus()
      }
    },
    closeTagsPopup (event) {
      let popup = this.$refs.taglist;
      let with_in_boundaries = event.composedPath().includes(popup);
      if (!with_in_boundaries) {
        this.open = false
      }
    }
  }
}

</script>
<style lang="scss">
.tag-list-popup {
  position: relative;
}
.tag-list-popup .tag-list ul,
.tag-list-popup .tag-list {
    margin: 0;
    padding: 0;
    border: none;
}
.tag-list-popup .tag-search-box {
  margin: 5px 0 0 !important;
  width: 100%;
}
  .tag-list-popup_title {
    position: relative;
    display: block;
    white-space: nowrap;
  }
    .tag-list-popup_title_text {
      font-size: 0.95rem;
      letter-spacing: 0.1rem;
      text-transform: uppercase;
      cursor: pointer;
    }
    .tag-list-popup_title_count {
      display: inline-block;
      vertical-align: middle;
      background: #DCDCDC;
      color: #000;
      border-radius: 0.75rem;
      padding: 0 0.5rem;
      font-weight: normal;
      transition: all ease 0.2s;
      text-align: center;
      cursor: pointer;
    }
    .tag-list-popup_title_count.is--active {
      background: #7A9E9F;
      color: #fff;
    }
  .tag-list-popup_content {
    position: absolute;
    top: 100%;
    right: 0;
    width: 100%;
    background: #fff;
    padding: 0;
    border-radius: 5px;
    border: 1px solid #DCDCDC;
    margin: 10px auto auto -100px;
    z-index: 998;
    text-transform: none;
    text-align: left;
    font-weight: normal;
    letter-spacing: normal;
    overflow: hidden;
    opacity: 0;
    transition: all ease 0.35s, opacity ease 0.15s;
    z-index: -1;
    &.select{
      height: 250px;
    }
    .tag-list-popup_content_wrapper {
      overflow: auto;
      width: 100%;
      height: 100%;
      max-height: 250px;
    }
  }
@media screen and (max-width: 767px) {
    // .tag-list-popup_content {
    //     position: relative;
    //     width: 100%;
    //     left: 0;
    //     margin: auto;
    // }
    .tag-list-popup.is--open {
      .tag-list-popup_content {
          margin-top: 10px;
      }
    }

}
  .tag-list-popup.is--open .tag-list-popup_content {
      /* max-width: 100vw;
      max-height: 100vh; */
      overflow: visible;
      opacity: 1;
      padding: 1rem;
      transition: all ease 0.15s, opacity ease 0.35s;
      z-index: 2;
  }

  .tag-list-popup_content:before,
  .tag-list-popup_content:after {
    content: " ";
    position: absolute;
    top: 0;
    left: 50%;
  }
  .tag-list-popup_content:before {
    z-index: 997;
    border-bottom: 10px solid #DCDCDC;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    margin: -10px auto auto -5px;
  }
  .tag-list-popup_content:after {
    z-index: 999;
    border-bottom: 9px solid #fff;
    border-left: 9px solid transparent;
    border-right: 9px solid transparent;
    margin: -9px auto auto -4px;
  }
</style>
